import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export class HoherPreisDialogInput {
    preis: number;
    position: number;
    artikel: string;
    menge: number;
}

@Component({
    selector: 'kiene-hoher-preis-dialog',
    templateUrl: './hoher-preis-dialog.component.html',
    styleUrls: ['./hoher-preis-dialog.component.scss'],
})
export class HoherPreisDialogComponent implements OnInit {
    constructor(
        public dialogRef: MatDialogRef<HoherPreisDialogComponent>,
        @Inject(MAT_DIALOG_DATA) protected data: HoherPreisDialogInput[] = [],
    ) {}

    ngOnInit(): void {}
}
